import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import { isColorBlockRun } from "../utils/logo";

Vue.use(VueRouter);

const UseAbout = () =>
  System.import(/* webpackChunkName: "about" */ "../views/About.vue");

const UseContact = () =>
  System.import(/* webpackChunkName: "about" */ "../views/Contact.vue");

const UsePrivacy = () =>
  System.import("../views/Privacy.vue");
const UseTerms = () =>
  System.import("../views/Terms.vue");

const routes = [
  {
    path: "*",
    redirect: "/",
  },
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "about",
    component: UseAbout,
  },
  {
    path: "/contact",
    name: "contact",
    component: UseContact,
  },
  {
    path: "/privacy",
    name: "privacy",
    component: UsePrivacy,
  },
  {
    path: "/terms",
    name: "terms",
    component: UseTerms,
  },
];

const router = new VueRouter({
  mode: "history",
  routes: routes,
});

router.beforeEach((to, from, next) => {
  if (isColorBlockRun() && (to.path === "/about" || to.path === "/contact")) {
    next("/");
    return;
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js